/**
 * ListConstants are constant values can be returned by list iteration methods
 * to denote special markers in the list.
 */
export var ListConstants;
(function (ListConstants) {
    /**
     * Denotes an empty value.
     *
     * The list should return this when there is nothing available to return.
     */
    ListConstants["NULL_VALUE"] = "NULL_VALUE";
    /**
     * The start of the list.
     */
    ListConstants["LIST_START"] = "LIST_START";
    /**
     * The end of the list.
     */
    ListConstants["LIST_END"] = "LIST_END";
    /**
     * The value cannot be returned due to restrictions.
     */
    ListConstants["FORBIDDEN"] = "FORBIDDEN";
})(ListConstants || (ListConstants = {}));
//# sourceMappingURL=list_constants.js.map